import React, { useCallback, useState } from "react";
import {
  Box,
  IconButton,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import ModalRegisterPetition from "../ModalRegisterPetition";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[600],
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.selected,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const ProcessPetitions = ({ petitions, processId, getProcess }) => {
  const [isModalCadastroPeticaoAberto, setIsModalCadastroPeticaoAberto] =
    useState(false);

  const toggleOpenModalCadastroPeticao = () => {
    setIsModalCadastroPeticaoAberto(!isModalCadastroPeticaoAberto);
  };

  return (
    <Paper sx={{ my: 1, p: 2 }}>
      <Stack width="100%" direction={"row"} justifyContent={"space-between"}>
        <Typography mb={2} variant="h6">
          Petições
        </Typography>
        <IconButton
          edge="end"
          aria-label="adicionar-peticao"
          onClick={toggleOpenModalCadastroPeticao}
        >
          <Tooltip title={"Adicionar petição"}>
            <AddIcon color="primary" />
          </Tooltip>
        </IconButton>
      </Stack>
      <TableContainer component={Paper}>
        <Table size="small" sx={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Pgto.</StyledTableCell>
              <StyledTableCell align="left">Protocolo</StyledTableCell>
              <StyledTableCell align="left">Data</StyledTableCell>
              <StyledTableCell align="left">IMG</StyledTableCell>
              <StyledTableCell align="left">Serviço</StyledTableCell>
              <StyledTableCell align="left">Cliente</StyledTableCell>
              <StyledTableCell align="left">Delivery</StyledTableCell>
              <StyledTableCell align="left">Data</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {petitions?.length > 0 ? (
              petitions?.map((petition) => (
                <StyledTableRow>
                  <StyledTableCell>
                    {petition?.pagamentos?.length > 0 ? (
                      <IconButton edge="end" aria-label="pagamento-peticao">
                        <Tooltip
                          title={`${
                            petition?.pagamentos[0]?.agencia_nome_banco
                          } - ${moment(petition?.pagamentos[0]?.data).format(
                            "DD/MM/YYYY"
                          )} - ${Intl.NumberFormat("pt-BR", {
                            currency: "BRL",
                            style: "currency",
                          }).format(petition?.pagamentos[0]?.valor)}`}
                        >
                          <CheckIcon color="success" />
                        </Tooltip>
                      </IconButton>
                    ) : (
                      <IconButton edge="end" aria-label="pagamento-peticao">
                        <Tooltip title="Sem pagamento">
                          <CloseIcon color="error" />
                        </Tooltip>
                      </IconButton>
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    {petition?.numero_protocolo ?? "- -"}
                  </StyledTableCell>
                  <StyledTableCell>
                    {petition?.data
                      ? moment.utc(petition?.data).format("DD/MM/YYYY")
                      : "- -"}
                  </StyledTableCell>
                  <StyledTableCell>{petition?.imagem ?? "- -"}</StyledTableCell>
                  <StyledTableCell>
                    {petition?.servico ?? "- -"}
                  </StyledTableCell>
                  <StyledTableCell>
                    {petition?.cliente ?? "- -"}
                  </StyledTableCell>
                  <StyledTableCell>
                    {petition?.delivery ?? "- -"}
                  </StyledTableCell>
                  <StyledTableCell>
                    {petition?.data_delivery ? moment.utc(petition?.data_delivery).format('DD/MM/YYYY') : "- -"}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <Box width={"100%"} p={2} textAlign={"center"}>
                Nenhuma publicação
              </Box>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <ModalRegisterPetition
        handleClose={toggleOpenModalCadastroPeticao}
        open={isModalCadastroPeticaoAberto}
        processId={processId}
        getProcess={getProcess}
      />
    </Paper>
  );
};
